import { Component, Input } from '@angular/core';

@Component({
    selector: 'lib-scorecard-section',
    templateUrl: './scorecard-section.component.html',
    styleUrls: ['./scorecard-section.component.scss'],
    standalone: false
})
export class ScorecardSectionComponent {

  @Input() heading: string;
  @Input() tooltip: string;

}
